import MaterialBox from "../../../../../__snowpack__/pkg/@mui/material/Box.js";
import styled from "styled-components";
export const OptionsContainer = styled(MaterialBox).withConfig({
  displayName: "select-optionsstyles__OptionsContainer",
  componentId: "sc-feuanh-0"
})(["", ""], {
  "--tw-bg-opacity": "1",
  backgroundColor: "rgba(255, 255, 255, var(--tw-bg-opacity))",
  borderTopRightRadius: "1rem",
  borderBottomRightRadius: "1rem",
  borderTopLeftRadius: "1rem",
  borderBottomLeftRadius: "1rem",
  overflow: "hidden",
  display: "flex",
  alignItems: "stretch",
  justifyContent: "space-between",
  marginBottom: "1rem"
});
export const BoxContainer = styled(MaterialBox).withConfig({
  displayName: "select-optionsstyles__BoxContainer",
  componentId: "sc-feuanh-1"
})(["", ""], {
  display: "flex",
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  paddingLeft: "1rem",
  paddingRight: "1rem"
});
export const SelectOptionsContainer = styled(MaterialBox).withConfig({
  displayName: "select-optionsstyles__SelectOptionsContainer",
  componentId: "sc-feuanh-2"
})(["", " & > *{", " & > span{", "}}& >:not(:last-child){", "}"], {
  display: "flex",
  alignItems: "stretch"
}, {
  paddingLeft: "0.5rem",
  paddingRight: "0.5rem",
  display: "flex",
  alignItems: "center",
  cursor: "pointer"
}, {
  cursor: "pointer"
}, {
  borderWidth: "0px",
  borderRightWidth: "2px",
  "--tw-border-opacity": "1",
  borderColor: "rgba(229, 231, 235, var(--tw-border-opacity))",
  borderStyle: "solid"
});
